import { gql } from '@apollo/client'

export const NOTIFY_RESILIA_TO_ADD_GOAL = gql`
  mutation NotifyResiliaToAddGoal($userId: Int!) {
    notifyResiliaToAddGoal(userId: $userId)
  }
`
